import { useEffect, memo } from "react";
import useScript from "../../utils/use-script";
import { validateUser } from "../../helper/api";

const scriptFlag = "__googleOneTapScript__";
const googleClientScriptURL = "https://accounts.google.com/gsi/client";

const OneTapLogin = ({
  clientId,
  nonce,
  context,
  autoSelect,
  promptParentId,
  stateCookieDomain,
  cancelOnTapOutside,
  nativeCallback,
  redirectURL,
  disable,
  setMember,
}) => {
  const script = useScript(googleClientScriptURL);

  const handleCallback = ({ credentialsResponse, redirectURL }) => {
    validateUser(credentialsResponse.credential, redirectURL).then((res) => {
      setMember(res.user);
    });
  };

  useEffect(() => {
    if (!disable) {
      if (!window[scriptFlag] && script === "ready") {
        window.google.accounts.id.initialize({
          nonce,
          context,
          client_id: clientId,
          auto_select: autoSelect,
          prompt_parent_id: promptParentId,
          state_cookie_domain: stateCookieDomain,
          cancel_on_tap_outside: cancelOnTapOutside,
          native_callback: nativeCallback,
          callback: (res) => handleCallback({ credentialsResponse: res, redirectURL }),
        });
        window[scriptFlag] = true;
        // UI Prompt isn't showing after delaying the script load,
        // So, Manually Triggering the UI
        window.google?.accounts?.id?.prompt();
      }
    } else {
      window.google?.accounts?.id?.cancel();
    }
  }, [
    script,
    disable,
    nonce,
    context,
    clientId,
    autoSelect,
    promptParentId,
    stateCookieDomain,
    cancelOnTapOutside,
    nativeCallback,
    redirectURL,
  ]);

  return null;
};

export default memo(OneTapLogin);
